import { render, staticRenderFns } from "./adminMain.vue?vue&type=template&id=f06d5d4c"
import script from "./adminMain.vue?vue&type=script&lang=js"
export * from "./adminMain.vue?vue&type=script&lang=js"
import style0 from "./adminMain.vue?vue&type=style&index=0&id=f06d5d4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports